//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import {
  mdiMapMarkerOutline,
  mdiSendOutline,
  mdiCloseCircleOutline,
  mdiMicrophone,
  mdiMapMarkerOffOutline,
} from '@mdi/js'

export default {
  setup() {
    const password = ref('Password')
    const show = ref(false)
    const message = ref('Hey!')
    const marker = ref(true)
    const iconIndex = ref(0)

    const toggleMarker = () => {
      marker.value = !marker.value
    }

    const clearMessage = () => {
      message.value = ''
    }
    const resetIcon = () => {
      iconIndex.value = 0
    }

    const sendMessage = () => {
      resetIcon()
      clearMessage()
    }

    return {
      password,
      show,
      message,
      marker,
      iconIndex,
      sendMessage,
      toggleMarker,
      clearMessage,
      mdiMapMarkerOutline,
      mdiSendOutline,
      mdiCloseCircleOutline,
      mdiMicrophone,
      mdiMapMarkerOffOutline,
    }
  },
}
